import React from 'react'
import { Modal } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { setPreferences, toggleSettingsDrawer } from '../../Redux/slices/Preferences/preferences'
import { useComponentLocale } from '../../hooks/useComponentLocale'
import { selectPreferences } from '../../Redux/selectors/selectors'
import SettingModalContent from './SettingsModalContent/SettingModalContent'
import styles from '../UserSettings.module.scss'

export default function SettingsModal() {
	const { isSettingsModalOpen, isModified, isFetchingData } = useSelector(selectPreferences)
	const dispatch = useDispatch()

	const getLocale = useComponentLocale()
	const themeSettingsLocale = getLocale({ component: 'theme', section: 'theme_settings' })

	const onCloseModal = () => {
		dispatch(toggleSettingsDrawer(false))
	}

	return (
		<Modal
			title={<h3 style={{ fontWeight: 400, marginBottom: 0 }}>{themeSettingsLocale}</h3>}
			centered
			onCancel={onCloseModal}
			onOk={() => dispatch(setPreferences())}
			okText='Submit'
			okButtonProps={{ disabled: !isModified || isFetchingData, loading: isFetchingData }}
			open={isSettingsModalOpen}
			closable
			width={1390}
			bodyStyle={{ padding: 0, height: '80vh' }}
			destroyOnClose
			className={styles.settingsModalWrapper}
		>
			<SettingModalContent />
		</Modal>
	)
}
